import * as React from "react";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { Route, Routes } from "react-router-dom";

import { PortalContent } from "../layouts/PortalLayout";
import Dashboard from "../features/dashboard/components/Dashboard";
import ProjectsMenu from "../features/projects/components/ProjectMenu";
import ProjectList from "../features/projects/components/ProjectList";
import CreateProject from "../features/projects/components/CreateProject";
import ProjectDetail from "../features/projects/components/ProjectDetail";
import ChangePassword from "../features/auth/components/AuthChangePassword";

const menuPages = {
  Dashboard: <Dashboard />,
  Projects: <ProjectsMenu />,
  Reports: <AssessmentIcon />,
};

/**
 * PortalRoutes - Routes for the portal section of the application
 * @return {JSX.Element} PortalRoutes component
 */
function PortalRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PortalContent />}>
        <Route index element={menuPages["Dashboard"]} />
        <Route path="projects" element={menuPages["Projects"]}>
          <Route index element={<ProjectList />} />
          <Route path="create_project" element={<CreateProject />} />
          <Route path=":id" element={<ProjectDetail />} />
        </Route>
        <Route path="reports" element={menuPages["Reports"]} />
        <Route path="change_password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
}

export default PortalRoutes;
